var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "border-1 rounded-xl shadow-md h-full flex flex-col-reverse pt-10 md:py-0",
    class: {
      'md:grid md:grid-cols-12 bg-white': _vm.position < 3,
      'col-span-2': _vm.position === 2,
      'bg-white md:bg-indigo-200 md:grid md:grid-cols-1 col-span-1 row-span-2': _vm.position === 3
    }
  }, [_vm.position > 1 ? _c('div', {
    staticClass: "relative flex flex-col items-center mt-10 md:mt-0",
    class: {
      'col-span-7 md:self-end md:pb-8 xl:pb-12': _vm.position < 3,
      'md:self-center md:py-0 xl:py-10': _vm.position === 3
    }
  }, [_c('illustration', {
    staticClass: "hidden md:block left-0 bottom-3 md:bottom-18 xl:bottom-16 lg:left-10 xl:left-3 xxl:left-14 2xl:left-28",
    class: {
      'absolute md:transform md:scale-80 lg:scale-85 xl:scale-100 xxl:scale-110 2xl:scale-x-125': _vm.position < 3,
      'md:transform md:scale-75 lg:scale-80 xl:scale-85 xxl:scale-100 2xl:scale-x-110': _vm.position === 3
    },
    attrs: {
      "name": "templates"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-4 mb-10 md:mb-0",
    class: {
      'md:pr-5 w-full': _vm.position < 3,
      'col-span-full md:p-5': _vm.position === 1,
      'col-span-5 md:mt-5': _vm.position === 2,
      'bg-white col-span-full md:py-5 md:rounded-xl md:shadow-lg md:px-5 md:m-2': _vm.position === 3
    }
  }, [_c('div', {
    staticClass: "text-2xl md:text-xl xl:text-2xl font-normal w-full text-center md:text-left"
  }, [_vm._v("\n      Modèles de pages\n    ")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "overflow-y-auto hide-scroll-bar h-60 md:h-44 xl:h-60"
  }, _vm._l(_vm.listPageTemplates, function (template, i) {
    return _c('div', {
      key: i,
      staticClass: "odd:bg-indigo-100 odd:bg-opacity-50 grid grid-cols-12 gap-2 items-center p-4 md:p-2.5 xl:p-3"
    }, [_c('div', {
      staticClass: "col-span-9 text-gray-600 text-base-0 font-normal"
    }, [_vm._v("\n            " + _vm._s(template.name) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-3",
      attrs: {
        "title": "Modifier le modèle de page"
      }
    }, [_vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_EDITER) ? _c('router-link', {
      staticClass: "text-indigo-600 rounded-full bg-pink-100 p-1 h-8 w-8 md:h-6 md:w-6 xl:w-8 xl:h-8 flex justify-center items-center",
      attrs: {
        "to": {
          name: template.type,
          params: {
            id_template: template.id,
            module: template.module_name,
            page: template.page_name
          }
        }
      }
    }, [_c('icon', {
      staticClass: "md:h-2 md:w-2 xl:w-3 xl:h-3 text-indigo-600",
      attrs: {
        "name": "edit",
        "label": "Modifier le modèle de page"
      }
    })], 1) : _c('span', {
      staticClass: "text-indigo-600 rounded-full bg-pink-100 p-1 h-8 w-8 md:h-6 md:w-6 xl:w-8 xl:h-8 flex justify-center items-center"
    }, [_c('icon', {
      staticClass: "md:h-2 md:w-2 xl:w-3 xl:h-3 text-indigo-600",
      attrs: {
        "name": "edit",
        "label": "Visualiser le modèle de page"
      }
    })], 1)], 1)]);
  }), 0)])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }